export interface DeliveryConfig {
  deliveryConfigId: number;
  requestDateTime: string;
  spacing: number;
  quantity: number;
}
